module.exports = __webpack_public_path__ + "static/img/no-credit.dbd8d60.svg";


//////////////////
// WEBPACK FOOTER
// ./static/images/no-credit.svg
// module id = Kl61
// module chunks = 1